import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function longitudeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    const isValid =
      /^-?((1[0-7][0-9]|[1-9]?[0-9])(\.\d{1,4})?|180(\.0{1,4})?)$/.test(value);
    return isValid ? null : { invalidLongitude: true };
  };
}

export function latitudeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    const isValid = /^-?([1-8]?[0-9](\.\d{1,4})?|90(\.0{1,4})?)$/.test(value);
    return isValid ? null : { invalidLatitude: true };
  };
}

export function geoLocationValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    const lettersRegex = /[a-zA-Z]/;
    const digitsRegex = /\d/;
    if (value) {
      for (let index = 0; index < value.length; index++) {
        if (lettersRegex.test(value[index])) {
          return { invalidGeoLocation: true };
        }

        if (!digitsRegex.test(value[index])) {
          const character = value[index];
          switch (character) {
            case "-":
              if (index != 0) {
                return { invalidGeoLocation: true };
              }
              break;
            case ".":
              break;
            default:
              return { invalidGeoLocation: true };
          }
        }
      }

      const geoLocationParts: string[] = String(value).split(".");
      if (geoLocationParts.length != 2 ||
          geoLocationParts[0].trim().length == 0 ||
          geoLocationParts[0] == "-" ||
          geoLocationParts[0].trim().length == 0 || geoLocationParts[1].trim().length == 0) {
        return { invalidGeoLocation: true };
      }

      if (!(Number(geoLocationParts[0]) > -180 &&
          Number(geoLocationParts[0]) < 180 &&
          geoLocationParts[1].length <= 53)) {
        return { invalidGeoLocation: true };
      }
     }
    return null;
  };
}
